import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "../components/Logo";
import { Footer } from "../components/Contact";
import { POLICY, UPDATED } from "../lib/privacyContent";

const Section = ({ s, i }) => (
  <section className="border-t border-emerald-500/15 py-8" data-testid={`privacy-section-${i}`}>
    <h2 className="font-display text-xl font-extrabold text-white sm:text-2xl">{i + 1}. {s.title}</h2>
    {s.body?.map((p) => <p key={p} className="mt-3 text-base leading-relaxed text-zinc-300">{p}</p>)}
    {s.list && (
      <ul className="mt-3 space-y-2">
        {s.list.map((li) => (
          <li key={li} className="flex gap-3 text-base leading-relaxed text-zinc-300"><span className="mt-2.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#00E676]" />{li}</li>
        ))}
      </ul>
    )}
    {s.after?.map((p) => <p key={p} className="mt-3 text-base leading-relaxed text-zinc-300">{p}</p>)}
  </section>
);

export default function Privacy() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Πολιτική Απορρήτου | KORANI CONSTRUCTION GROUP";
    window.scrollTo(0, 0);
    return () => { document.title = prev; };
  }, []);
  return (
    <div className="min-h-screen bg-[#050706] text-white">
      <header className="border-b border-emerald-500/15">
        <div className="mx-auto flex h-[70px] max-w-[900px] items-center justify-between px-5 sm:px-8">
          <Link to="/" className="flex items-center gap-3" data-testid="privacy-home-link">
            <LogoMark className="h-9 w-9" />
            <span className="font-display text-[15px] font-extrabold tracking-[0.18em]">KORANI<span className="text-[#00E676]"> GROUP</span></span>
          </Link>
          <Link to="/" className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-white" data-testid="privacy-back-link"><ArrowLeft className="h-4 w-4" />Αρχική</Link>
        </div>
      </header>
      <main className="mx-auto max-w-[900px] px-5 py-14 sm:px-8 sm:py-20" data-testid="privacy-page">
        <p className="eyebrow">KORANI CONSTRUCTION GROUP</p>
        <h1 className="mt-4 font-display text-4xl font-black uppercase tracking-[-0.02em] sm:text-5xl" data-testid="privacy-title">Πολιτική Απορρήτου</h1>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Τελευταία ενημέρωση: {UPDATED}</p>
        <p className="mt-8 text-base leading-relaxed text-zinc-300">
          Η παρούσα Πολιτική Απορρήτου εξηγεί ποια προσωπικά δεδομένα συλλέγουμε μέσω της ιστοσελίδας koranigroup.com και της εφαρμογής KORANI GROUP για Android,
          για ποιο σκοπό, πού αποθηκεύονται και ποια δικαιώματα έχετε σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 (GDPR) και την ελληνική νομοθεσία (ν. 4624/2019).
        </p>
        <div className="mt-10">{POLICY.map((s, i) => <Section key={s.title} s={s} i={i} />)}</div>
      </main>
      <Footer />
    </div>
  );
}
